/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import {
    string, func, object, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import { getCustomCardData } from '../../../../../state/ducks/App/App-Selectors';
import findContent from '../../../../gql/queries/findContent';
import CelebrationsCustomsCardView from './CelebrationsCustomsCardView';
import GraphqlPortalLoader from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const styles = (theme) => ({
    noHangtagLabel: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.palette.cms?.bgSelectColor || '#b01116',
    },
});
const GraphlqlCelebrationsCustomsCard = ({
    classes, personalizationCustomsType, closeModal, updateCGCCustomsData,
    cartItemId, openModal, customCardData, existingData, brand,
    setCGCLabelData,
}) => {
    let customsContentType = '';
    let customType = '';
    const pType = personalizationCustomsType?.substring(0, 2);
    // isCherylsBrand is aused to enable only hangtags for cheryls brand
    const isCherylsBrand = brand?.id === '1012';
    if (pType === 'HT' || (pType !== 'HT' && existingData?.card_type === 'hangtag') || isCherylsBrand) {
        customsContentType = 'hangtags';
        customType = 'hangtag';
    }
    if (pType === 'PL' || (pType !== 'PL' && existingData?.card_type === 'label')) {
        customsContentType = 'labels';
        customType = 'label';
    }
    const query = `\\"product_sku\\": \\"${cartItemId}\\"`;
    const CUSTOMS_QUERY = findContent({ brand: 'gci', contentType: customsContentType, query });
    const { data, error, loading } = useQuery(CUSTOMS_QUERY);
    let response = null;

    if (loading && !data && !error) { // data and error are checked for an edge case that happens by useQuery w.r.t loading flag.
        response = <GraphqlPortalLoader />;
    } else if (error || !data) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: CUSTOMS_QUERY,
            component: 'GraphlqlCelebrationsCustomsCard.js',
            message: `Failed to fetch content data for: content type ${customsContentType},query ${query} on brand gci`,
            error,
        });
        response = null;
    } else if (data?.findContent?.content?.entries) {
        const customItems = data.findContent.content.entries?.[0];
        response = (
            customItems
                ? (
                    <CelebrationsCustomsCardView
                        key={customItems?.uid}
                        customData={customItems}
                        closeModal={closeModal}
                        cartItemId={cartItemId}
                        customType={customType}
                        openModal={openModal}
                        updateCGCCustomsData={updateCGCCustomsData}
                        customCardData={customCardData}
                        setCGCLabelData={setCGCLabelData}
                    />
                )
                : <p className={classes.noHangtagLabel}>No Hangtag or Label available for this Product</p>
        );
    }
    return response;
};
GraphlqlCelebrationsCustomsCard.propTypes = {
    classes: object.isRequired,
    cartItemId: string.isRequired,
    personalizationCustomsType: string.isRequired,
    closeModal: func.isRequired,
    updateCGCCustomsData: func.isRequired,
    existingData: shape({
        card_type: string,
    }),
    brand: shape({
        id: string,
    }).isRequired,
    setCGCLabelData: func.isRequired,
};
const mapStateToProps = (state) => ({
    brand: getBrand(state),
    existingData: getCustomCardData(state),
});
export default  connect(mapStateToProps, null)((withStyles(styles)(GraphlqlCelebrationsCustomsCard)));
